import { FeaturedContentBlock } from "graphql/generated-types";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import ArrowLink from "../ArrowLink";

type Props = Omit<
	FeaturedContentBlock & {
		container?: boolean;
		i?: number;
	},
	"blockType" | "rawValue" | "field" | "blocks"
>;
const FeaturedContent = ({ title, content, image, link, linkText, container = false, i }: Props) => {
	return (
		<section
			className={`to-lg:border-l-3 border-pink group even:flex-row-reverse lg:flex gap-8${
				container ? "to-lg:ml-3 container lg:my-[4vw] 2xl:my-32" : "to-lg:pl-3"
			}`}
		>
			{image && link ? (
				<Link href={link} className="overflow-hidden lg:w-2/3">
					<Image
						className="w-full duration-500 group-hover:scale-105"
						src={image?.rendition?.url!}
						width={615}
						height={600}
						alt={image.rendition?.image.title!}
					/>
				</Link>
			) : (
				<div className="overflow-hidden lg:w-2/3">
					<Image
						className="w-full"
						src={image?.rendition?.url!}
						width={615}
						height={600}
						alt={image?.rendition?.image.title!}
					/>
				</div>
			)}

			<div className="to-lg:mt-4 flex flex-col lg:mr-12 lg:w-1/3">
				<h2 className="-mt-2.5 text-lg lg:text-xl">{title}</h2>
				<div className="prose mt-1 text-base lg:mt-4" dangerouslySetInnerHTML={{ __html: content }} />
				{link && linkText && <ArrowLink className="mt-12 lg:mt-auto" href={link} text={linkText} />}
			</div>
			<div className="to-lg:hidden bg-pink w-[3px] self-stretch" />
		</section>
	);
};

export default FeaturedContent;
